import React from 'react';
import styled from '@emotion/styled';
import { colors } from '../theme/colors';

const MatchStatusSquare = styled.div`
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  width: 100%;
  height: calc(100% + 24px);
  
  ${props => props.matchLevel === 'HIGH' && `
    background: ${colors.success};
  `}
  
  ${props => props.matchLevel === 'MEDIUM' && `
    background: ${colors.warning};
  `}
  
  ${props => props.matchLevel === 'LOW' && `
    background: ${colors.error};
  `}
  
  ${props => props.matchLevel === 'NO_MATCH' && `
    background: #d1d5db;
  `}
`;

const MatchStatusIcon = ({ matchLevel }) => {
  return (
    <MatchStatusSquare 
      matchLevel={matchLevel} 
      title={`Match Level: ${matchLevel}`}
    />
  );
};

export default MatchStatusIcon;
